// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseSplitApi = createApi({
  baseQuery: fetchBaseQuery({ 
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const accessToken =  localStorage.getItem('accessToken');
      
      if (accessToken) {
        headers.set('authorization', `${accessToken}`);
      }

      return headers;
    } 
  }),
  endpoints: () => ({
  }),
})